var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitylog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9506,
    cy: 4.04242,
    r: 2.31,
    stroke: "#636980"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.7497C6.16667 11.583 6.5 9.25035 7.5 8.75C9.33333 8.25 12.6 8.05035 13 9.25035C13.5 10.7503 14 12.7499 17 11.2499",
    stroke: "#636980",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0712 19.5071C13.2132 19.7439 13.5203 19.8208 13.7571 19.6788C13.9939 19.5368 14.0708 19.2297 13.9288 18.9929L13.0712 19.5071ZM9.50714 8.67929C9.42189 9.27599 9.31979 10.2195 9.28989 11.1209C9.27495 11.5713 9.27766 12.021 9.31177 12.4164C9.34455 12.7963 9.41035 13.1845 9.5549 13.4736L10.4493 13.0264C10.3939 12.9155 10.3388 12.687 10.3081 12.3305C10.2786 11.9894 10.2751 11.5829 10.2893 11.1541C10.3178 10.2971 10.4157 9.39068 10.4971 8.82071L9.50714 8.67929ZM9.5549 13.4736C9.96597 14.2957 12.079 17.8524 13.0712 19.5071L13.9288 18.9929C12.9224 17.3143 10.8383 13.8043 10.4493 13.0264L9.5549 13.4736Z",
    fill: "#636980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.75L6 19.75",
    stroke: "#636980",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitylog);
export default __webpack_public_path__ + "static/media/activitylog.05e8456e59b7f1b331e14dd2550bc12b.svg";
export { ForwardRef as ReactComponent };